import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
//import "../css/app.css";
//import "../js/app.js";
import "../css/Formpopup.css";
import "../css/DatatableStyle.css";
import "bootstrap-icons/font/bootstrap-icons.css";

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  displayPosition?: number;   // ← add ? to make it optional
  subMenuList?: SubMenuItem[];
}

interface SubMenuItem {
  subMenuId: number;
  subMenuName: string;
  subMenuUrl: string;
}

interface SidebarProps {
  collapsed: boolean;
  allowedMenus: MenuItem[];
  isLoading: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  allowedMenus,
  isLoading,
}) => {
  // Use React Router's useLocation hook to get the current path
  const location = useLocation();
  const currentPath = location.pathname;
  const [activeMenuId, setActiveMenuId] = useState<number | null>(null);

  const generateMenuConfig = (allowedMenus: MenuItem[]) => {
    return allowedMenus.reduce((acc, menuItem) => {
      acc[menuItem.menuID] = {
        icon: "bi-gear",
        route: createFullUrl(menuItem.menuUrl),
      };
      return acc;
    }, {} as Record<number, { icon: string; route: string }>);
  };

  const createFullUrl = (path: string) => {
    const baseUrl = window.location.origin;

    const formattedPath = path
      ? `${path.toLowerCase().replace(/\s+/g, "-")}`
      : "/";
    return `${baseUrl}${formattedPath}`;
  };

  const menuConfig = generateMenuConfig(allowedMenus);

  const getMenuConfig = (menuID: number) => {
    return menuConfig[menuID] || { icon: "bi-gear", route: "/" };
  };

  // Function to handle submenu click
  const handleSubmenuClick = (parentMenu: MenuItem, subMenu: SubMenuItem) => {
    // You can add additional logic here if needed
    setActiveMenuId(parentMenu.menuID);
  };

  return (
    <nav
      id="sidebar"
      className={`sidebar js-sidebar ${collapsed ? "collapsed" : ""}`}
    >
      <div className="sidebar-content js-simplebar" data-simplebar="init">
        <div className="simplebar-wrapper" style={{ margin: "0px" }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div
              className="simplebar-offset"
              style={{ right: "0px", bottom: "0px" }}
            >
              <div
                className="simplebar-content-wrapper"
                tabIndex={0}
                role="region"
                aria-label="scrollable content"
                style={{ height: "100%", overflow: "hidden scroll" }}
              >
                <div className="simplebar-content" style={{ padding: "0px" }}>
                  <Link className="sidebar-brand" to="/">
                    <span className="align-middle">Real Estate CRM</span>
                  </Link>

                  <ul className="sidebar-nav">
                    {isLoading ? (
                      <li className="sidebar-item">
                        <span className="sidebar-link">
                          <i className="bi bi-hourglass align-middle"></i>
                          <span className="align-middle">Loading...</span>
                        </span>
                      </li>
                    ) : (
                      allowedMenus.map((menuItem) => {
                        const { icon, route } = getMenuConfig(menuItem.menuID);
                        const isActive = currentPath === route;

                        return (
                          <li
                            key={menuItem.menuID}
                            className={`sidebar-item ${
                              isActive || activeMenuId === menuItem.menuID
                                ? "active"
                                : ""
                            }`}
                          >
                            <div className="button2 d-flex align-items-center">
                              <div className="mx-auto">
                                <i className={`bi ${icon} align-middle`}></i>
                                <span>{menuItem.menuName}</span>
                              </div>
                              <div className="popup-div">
                                <ul className="list-group text-start">
                                  {menuItem.subMenuList &&
                                    menuItem.subMenuList.length > 0 &&
                                    menuItem.subMenuList.map(
                                      (subMenu: SubMenuItem) => (
                                        <Link
                                          key={subMenu.subMenuId}
                                          className="list-group-item"
                                          to={createFullUrl(subMenu.subMenuUrl)}
                                          onClick={(e) => {
                                            handleSubmenuClick(
                                              menuItem,
                                              subMenu
                                            );
                                          }}
                                          data-menu-id={menuItem.menuID}
                                          data-menu-name={menuItem.menuName}
                                          data-submenu-id={subMenu.subMenuId}
                                        >
                                          {subMenu.subMenuName}
                                        </Link>
                                      )
                                    )}
                                </ul>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            className="simplebar-placeholder"
            style={{ width: "auto", height: "891px" }}
          ></div>
        </div>
        <div
          className="simplebar-track simplebar-horizontal"
          style={{ visibility: "hidden" }}
        >
          <div
            className="simplebar-scrollbar"
            style={{ width: "0px", display: "none" }}
          ></div>
        </div>
        <div
          className="simplebar-track simplebar-vertical"
          style={{ visibility: "visible" }}
        >
          <div
            className="simplebar-scrollbar"
            style={{
              height: "144px",
              transform: "translate3d(0px, 215px, 0px)",
              display: "block",
            }}
          ></div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
